import React from 'react';
import Moment from 'moment';
import HelperBusiness from './Business';
import { Link } from 'react-router-dom';



class HelperClients {


  // Avatar image

  getImage(client) {
    if(client !== null && client !== undefined) {
      if(client.data.image === '') {
        var inits = ''
        let arr = client.data.name.split(' ')
        if(arr.length > 1) {
          inits = arr[0].charAt(0)+arr[1].charAt(0)
        } else {
          inits = arr[0].charAt(0)
        }
        if(client.data.avatar !== undefined && client.data.avatar !== '') {
          return (
            <div className={'avatar '+client.data.avatar}></div>
          )
        } else {
          return (
            <div className="avatar">
              <p>{inits}</p>
            </div>
          )
        }
        
      } else {
        var img = ''
        for(var item of global.clientsImages) {
          if(item.id === client.id) {
            img = item.image
          }
        }
        return (
          <div className="avatar" style={{backgroundImage: 'url('+img+')'}}> </div>
        )
      }
    } else {
      return (
        <div className="avatar"><p>?</p></div>
      )
    }
  }


  getImageEdit(client) {
    if(client !== null && client !== undefined) {
      if(client.data.image === '') {
        var inits = ''
        let arr = client.data.name.split(' ')
        if(arr.length > 1) {
          inits = arr[0].charAt(0)+arr[1].charAt(0)
        } else {
          inits = arr[0].charAt(0)
        }
        return (
          <div className="avatar"><p>✎</p></div>
        )
      } else {
        var img = ''
        for(var item of global.clientsImages) {
          if(item.id === client.id) {
            img = item.image
          }
        }
        return (
          <div className="avatar" style={{backgroundImage: 'url('+img+')'}}> </div>
        )
      }
    } else {
      return (
        <div className="avatar"><p>?</p></div>
      )
    }
  }


  // Form status

  getForm(client, form, type, pre, list) {
    var label = 'Not sent yet'
    if(pre || list === 'response') {
      label = 'Not completed yet'
    }
    if(type === 'version') {
      label = ' '
    }
    for(var item of client.forms) {
      if(item.id === form) {
        label = 'Already sent'
        
        if(item.data.date !== undefined) {
          label = 'Completed on '+Moment(item.data.date, 'X').format('D MMM YYYY')
        } else {
          if(pre || list === 'response') {
            label = 'Not completed yet'
          }
        }
        if(type === 'version') {
          label = 'Version '+item.data.version
        }
      }
    }
    return label
  }


  // Notification badges

  getDotBirthday(client) {
    var show = false
    let day = Moment(client.data.birth, 'DD/MM/YYYY').format('DD/MM')
    let yr = Moment().format('YYYY')
    let date = Moment(day+'/'+yr, 'DD/MM/YYYY').format('X')
    let advance = Moment().add(5, 'days').format('X')
    if((date < advance && date >= Moment().format('X')) || day === Moment().format('DD/MM')) {
      show = true
    }
    if(show) {
      return (
        <div className="bullet quarternary" title={'Birthday on '+Moment(client.data.birth, 'DD/MM/YYYY').format('D MMMM')}></div>
      )
    }
  }


  renderButton(item, active) {
    if(active || active === undefined) {
      return (
        <Link to={'/clients/'+item+'/details'} className="btn tertiary small rgt">Manage account</Link>
      )
    }
  }


  // Format phone number

  getPhone(number) {
    var label = number
    if(number.indexOf('04') !== -1) {
      var l1 = number.substring(0, 4)
      var l2 = number.substring(4, 7)
      var l3 = number.substring(7, number.length)
      label = l1+" "+l2+" "+l3
    }
    return label
  }


  // Family account banner

  getFamily(item) {
    if(item !== null && HelperBusiness.getRoleIncl('trainer,admin,finance,cs')) {
      if(item.data.parent !== undefined && item.data.parent !== '') {
        var name = 'another member'
        for(var cl of global.clients) {
          if(cl.id === item.data.parent) {
            name = cl.data.name
          }
        }
        return (
          <div className="infobox large primary mb-30">
            <p>Part of a Family Account managed by {name}{this.renderButton(item.data.parent, item.data.active)}</p>
          </div>
        )
      } else if(item.data.linked !== undefined) {
        return (
          <div className="infobox large green mb-30">
            <p>This is the main profile for a family account{this.renderButton(item.id, item.data.active)}</p>
          </div>
        )
      }
    }
  }

}


const b = new HelperClients();
export default b;